export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6393.d17a7ea3.jpg";